<template>
  <vs-row
    v-if="this.$session.get('username') == 'sscoil'"
    vs-type="flex"
    vs-justify="space-between"
    vs-w="12"
  >
    <vs-col vs-type="flex" vs-justify="center" vs-w="4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #def1ff, #def1ff);
          border-radius: 15px;
        "
      >
        <div class="box" @click="gotopagegateway">
          <vs-row
            ><h3 class="text-info headerOverview">Gateway</h3>
            <vs-spacer />
            <div class="col-lg-3 col-md-6 m-b-30 text-center">
              <small>Active </small>
              <h3 class="text-info">
                <b>{{ gw }}/{{ gwl }}</b>
              </h3>
              <div id="sparklinedash">
                <canvas
                  width="144"
                  height="30"
                  style="
                    display: inline-block;
                    width: 144px;
                    height: 30px;
                    vertical-align: top;
                  "
                ></canvas>
              </div>
            </div>
          </vs-row>

          <!-- <p class="mt-3 mb-0 text-sm"><span class="textSuccess mr-2">
        <i class="fa fa-arrow-up"></i> 50%</span><span class="text-nowrap">Active Gateway</span></p> -->
          <p class="mt-3 mb-0 text-sm">
            <span class="text-nowrap">Active Gateway</span>
          </p>
          <vs-progress :height="8" :percent="(gw / tgw) * 100" color="#189AFA"
            >primary</vs-progress
          >
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-w="4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #dbf7d7, #dbf7d7);
          border-radius: 15px;
        "
      >
        <div class="box" @click="gotopagetag">
          <vs-row
            ><h3 class="textSuccess headerOverview">Active Tag</h3>
            <vs-spacer />
            <div class="col-lg-3 col-md-6 m-b-30 text-center">
              <small>Active </small>
              <h3 class="textSuccess">
                <b>{{ ss }}/{{ tss }}</b>
              </h3>
              <div id="sparklinedash">
                <canvas
                  width="144"
                  height="30"
                  style="
                    display: inline-block;
                    width: 144px;
                    height: 30px;
                    vertical-align: top;
                  "
                ></canvas>
              </div>
            </div>
          </vs-row>

          <p class="mt-3 mb-0 text-sm">
            <span class="text-nowrap">Active Sensor</span>
          </p>
          <vs-progress :height="8" :percent="(ss / tss) * 100" color="#5fa74b"
            >primary</vs-progress
          >
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-w="4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #ffdfdb, #ffdfdb);
          border-radius: 15px;
        "
      >
        <vs-row
          ><h3 class="text-danger headerOverview">Alert</h3>
          <vs-spacer /><vs-icon
            icon="report_problem"
            size="60px"
            color="danger"
          ></vs-icon></vs-row
        ><br />
        <br />
        <span>
          <vs-icon icon="notifications_none" color="danger"></vs-icon>
        </span>
        <span>
          <vs-icon icon="notifications_none" color="danger"></vs-icon>
        </span>
        <span>
          <vs-icon icon="notifications_none" color="danger"></vs-icon>
        </span>
        <span>
          <vs-icon icon="notifications_none" color="danger"></vs-icon>
        </span>
        <span>
          <vs-icon icon="notifications_none" color="danger"></vs-icon>
        </span>
      </vs-card>
    </vs-col>

    <div class="container-fluid">
      <vs-popup fullscreen title="fullscreen" :active.sync="popupActive">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </vs-popup>
    </div>
  </vs-row>
  <vs-row v-else vs-type="flex" vs-w="12">
    <vs-col vs-type="flex" vs-justify="center" vs-w="2.4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #F7DFFF, #F7DFFF);
          border-radius: 15px;
        "
      >
      
        <div class="box" @click="gotopagegateway">
          <vs-row>
            <h3 class="headerOverview " style="color: #A400DE">Gateway</h3>
            <vs-spacer />
            <div class="col-lg-3 col-md-6 m-b-30 text-center">
              <small>Active </small>
              <h3 style="color: #A400DE">
                <b>{{ asg }}/{{ gwl }}</b>
              </h3>
              <div id="sparklinedash">
                <canvas
                  width="144"
                  height="30"
                  style="
                    display: inline-block;
                    width: 144px;
                    height: 30px;
                    vertical-align: top;
                  "
                ></canvas>
              </div>
            </div>
          </vs-row>

          <!-- <p class="mt-3 mb-0 text-sm"><span class="textSuccess mr-2">
        <i class="fa fa-arrow-up"></i> 50%</span><span class="text-nowrap">Active Gateway</span></p> -->
          <p class="mt-3 mb-0 text-sm">
            <span class="text-nowrap">Active Gateway</span> 
          </p>
          <vs-progress :height="8" :percent="(asg / gwl) * 100" color="#A400DE"
            >primary</vs-progress
          >
        </div>
      </vs-card>
    </vs-col>

    <vs-col vs-type="flex" vs-justify="center" vs-w="2.4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #DFE2FF, #DFE2FF);
          border-radius: 15px;
        "
      >
        <div class="box" @click="gotopagetag">
          <vs-row>
            <h3 class="headerOverview " style="color: #5767FF">Tag</h3>
            <vs-spacer />
            <div class="col-lg-3 col-md-6 m-b-30 text-center">
              <small>Active </small>
              <h3 style="color: #5767FF">
                <b>{{ tff }}/{{ tcf }}</b>
              </h3>
              <div id="sparklinedash">
                <canvas
                  width="144"
                  height="30"
                  style="
                    display: inline-block;
                    width: 144px;
                    height: 30px;
                    vertical-align: top;
                  "
                ></canvas>
              </div>
            </div>
          </vs-row>

          <!-- <p class="mt-3 mb-0 text-sm"><span class="textSuccess mr-2">
        <i class="fa fa-arrow-up"></i> 50%</span><span class="text-nowrap">Active Gateway</span></p> -->
          <p class="mt-3 mb-0 text-sm">
            <span class="text-nowrap">Active Tag</span>
          </p>
          <vs-progress :height="8" :percent="(tff / tcf) * 100" color="#5767FF"
            >primary</vs-progress
          >
        </div>
      </vs-card>
    </vs-col>

    <vs-col vs-type="flex" vs-justify="center" vs-w="2.4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #DEF1FF, #DEF1FF);
          border-radius: 15px;
        "
      >
        <div class="box" @click="gotopageasset">
          <vs-row>
            <h3 class="text-info headerOverview">Asset</h3>
            <vs-spacer />
            <div class="col-lg-3 col-md-6 m-b-30 text-center">
              <small>Active </small>
              <h3 style="color: #189AFA">
                <b>{{ asc }}/{{ acf }}</b>
              </h3>
              <div id="sparklinedash">
                <canvas
                  width="144"
                  height="30"
                  style="
                    display: inline-block;
                    width: 144px;
                    height: 30px;
                    vertical-align: top;
                  "
                ></canvas>
              </div>
            </div>
          </vs-row>

          <!-- <p class="mt-3 mb-0 text-sm"><span class="textSuccess mr-2">
        <i class="fa fa-arrow-up"></i> 50%</span><span class="text-nowrap">Active Gateway</span></p> -->
          <p class="mt-3 mb-0 text-sm">
            <span class="text-nowrap">Active Asset</span>
          </p>
          <vs-progress :height="8" :percent="(asc / acf) * 100" color="#189AFA"
            >primary</vs-progress
          >
        </div>
      </vs-card>
    </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-w="2.4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #DBF7D7, #DBF7D7);
          border-radius: 15px;
        "
      >
        <div class="box" @click="gotopagesensor">
          <vs-row
            ><h3 class="textSuccess headerOverview">Sensor</h3>
            <vs-spacer />
            <div class="col-lg-3 col-md-6 m-b-30 text-center">
              <small>Active </small>
              <h3 class="textSuccess">
                <!-- <b>{{ ss }}/{{ tss }}</b> -->
                <b>0/0</b>
              </h3>
              <div id="sparklinedash">
                <canvas
                  width="144"
                  height="30"
                  style="
                    display: inline-block;
                    width: 144px;
                    height: 30px;
                    vertical-align: top;
                  "
                ></canvas>
              </div>
            </div>
          </vs-row>

          <p class="mt-3 mb-0 text-sm">
            <span class="text-nowrap">Active Sensor</span>
          </p>
          <!-- <vs-progress :height="8" :percent="(ss / tss) * 100" color="#32c040" -->
          <vs-progress :height="8" :percent="(0 / 0) * 100" color="#32c040"
            >primary</vs-progress
          >
        </div>
      </vs-card>
    </vs-col>

    <vs-col vs-type="flex" vs-justify="center" vs-w="2.4" vs-sm="6" vs-xs="12">
      <vs-card
        class="boxShadow"
        style="
          background: linear-gradient(45deg, #ffdfdb, #ffdfdb);
          border-radius: 15px;
        "
      >
        <div class="box" @click="gotopagealert">
          <vs-row
            ><h3 class="headerOverview " style="color: red">Alert</h3>
            <vs-spacer /><vs-icon
              icon="report_problem"
              size="60px"
              color="danger"
            ></vs-icon
          ></vs-row>
          <br />
          <br />
          <h2 class="text-danger">
            <b>{{ alertlist.length }}</b>
          </h2>
        </div>
      </vs-card>
    </vs-col>

    <div class="container-fluid">
      <vs-popup fullscreen title="fullscreen" :active.sync="popupActive">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </vs-popup>
    </div>
  </vs-row>
</template>
<script>
import moment from "moment";

export default {
  name: "activestate",

  props: ["calldata"],
  data: () => ({
    action: [],
    popupActive: false,
    alertlist: [],
    ss: 0,
    gw: 0,
    tss: 0,
    tgw: 0,
    gwl: 0,
    gff: 0,
    tff: 0,
    tcf: 0,
    acf: 0,
    aff: 0,
    asc: 0,
    asg: 0,
  }),
  methods: {
    gotopagegateway() {
      this.$router.push({ path: "../IndoorGateway" });
    },
    gotopagetag() {
      this.$router.push({ path: "../IndoorTag" });
    },
    gotopageasset() {
      this.$router.push({ path: "../IndoorEsset" });
    },
    
    gotopagesensor() {
      this.$router.push({ path: "/sensor" });
    },
    gotopagealert() {
      this.$router.push({ path: "/alert" });
    },
    gotopageWorkOrder() {
      this.$router.push({ path: "/workorder" });
    },
  },
  created() {
    this.$API
      .get("indoortag")
      .then((result) => {
        this.tcf = result.data.length;
        
        console.log(this.tcf);
        // for(var i=0; i < this.gwl; i++){
        //   let obj = result.data[i];
        //   // if(obj.found != null){
        //   //     this.gff++;
        //   //     console.log(this.gff);
        //   // }
        // }
      });

      this.$API
      .get("indoorasset")
      .then((result) => {
        this.acf = result.data.length;
        console.log(this.tff);
        
        // for(var i=0; i < this.gwl; i++){
        //   let obj = result.data[i];
        //   // if(obj.found != null){
        //   //     this.gff++;
        //   //     console.log(this.gff);
        //   // }
        // }
      });
      this.$API
      .get("indoorgateway")
      .then((result) => {
        console.log(result);
        this.gwl = result.data.length;
        console.log(result.data.lastdate);
        console.log(this.gwl);
        console.log(this.tff);
        
        for(var i=0; i < this.gwl; i++){
          let obj = result.data[i];
          if(obj.tagfound != null){
              this.gff++;
              console.log(this.gff);
          }
        }

        console.log(moment(result.data.lastdate).format('Do h:mA'));
        //  moment(result.data[0].lastdate).format('Do hA')    == moment().format('Do hA')
        var currentTime = Date.now()
        currentTime = moment(currentTime)


         result.data.forEach((element) => {
           var timeDiff = currentTime.diff(moment(element.lastdate),'m')
           if(timeDiff <= 2){
             this.asg++;
           }
           if(moment(element.lastdate).format('Do h:mA') == moment().format('Do h:mA')){
             console.log("Done");
            
           }
            console.log(timeDiff);
            console.log(this.asg);
         });
      });
      this.$API
      .get("indoorgateway/AC233FC064BF")
      .then((result) => {
        console.log(result.data.assetfound);
        if(result.data.assetfound = 'undefined'){
          console.log("not");
        }
        else{
          console.log(result.data.assetfound.length);
        }
        // for(var i=0; i < this.gwl; i++){
        //   let obj = result.data[i];
        //   // if(obj.found != null){
        //   //     this.gff++;
        //   //     console.log(this.gff);
        //   // }
        // }
      });


      this.$API
      .get("indoortaglog/AC233FC064DB")
      .then((result) => {
        
        console.log(result.data.length);
        // for(var i=0; i < this.gwl; i++){
        //   let obj = result.data[i];
        //   // if(obj.found != null){
        //   //     this.gff++;
        //   //     console.log(this.gff);
        //   // }
        // }
      });

      this.$API
      .get("indoorasset")
      .then((result) => {
        
        console.log(result.data)
        console.log(moment(result.data[0].lastdate).format('Do h:mA'));
        //  moment(result.data[0].lastdate).format('Do hA')    == moment().format('Do hA')
        var currentTime = Date.now()
        currentTime = moment(currentTime)


        result.data.forEach((element) => {
          var timeDiff = currentTime.diff(moment(element.lastdate),'m')
          if(timeDiff <= 2){
            this.asc++;
          }
          if(moment(element.lastdate).format('Do h:mA') == moment().format('Do h:mA')){
            console.log("Done");
            
          }
           console.log(timeDiff);
           console.log(this.asc);
        });
      });

    this.$API
      .get("count")
      .then((result) => {
        this.ss = result.data.ss;
        this.tss = result.data.tss;
        this.tgw = result.data.tgw;
        this.gw = result.data.gw;
      });
    this.$API
      .get("alertlog/user")
      .then((result) => {
        // this.alertlist = result.data
        console.log(result.data)
        result.data.forEach((element, i) => {
          element.alerthistory.forEach((el) => {
            if (tempel.alsertstatus == true) {
              tempel = el;
              tempel.alertname = element.alertname;
              tempel.alertstatus = element.alertstatus;
              tempel.sensorname = element.sensorname;
              // if(j == 0) {
              //   this.alertlist.push(el)
              //   j++
              // }
              // if(j != 0 && this.alertlist[j].name != this.alertlist[j-1].name) {
              //   this.alertlist.push(el)
              //   j++
              // }
              this.alertlist.push(el);
              tempel = {};
            }
          });
        });
        console.log(this.alertlist);
      });
    this.action = this.calldata;
  },
};
</script>

<style lang="stylus" scoped>
.box {
  cursor: pointer;
}

body {
  padding-top: 200px;
}

.card {
  height: 70%;
  margin-bottom: 80px;
  width: 95%;
  position: relative;
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0px 7px 30px 2px rgba(0, 0, 0, 0.18);

  ul>li {
    img {
      width: 30px;
    }

    font-size: 17px;
  }

  h1 {
    position: absolute;
    left: 10px;
    bottom: 0px;
  }

  .date {
    position: absolute;
    right: 10px;
    top: 10px;
    text-align: right;
  }

  .city {
    position: absolute;
    right: 10px;
    bottom: 0px;
    color: #ffffff;
  }
}

.list-inline {
  margin-bottom: 0 !important;
}

h3 {
  margin: 0 !important;
}

.content {
  display: flex;
  flex-wrap: wrap;
}
</style>
